import { MAX_UCAS_TARIFF } from '@uc/web/shared/data-access';
import { gql } from 'graphql-tag';

const GET_COURSES = gql`
	query getCourses(
		$degreeLevel: CourseDegreeLevel = ALL_UNDERGRADUATE
		$tariffMin: Int = 0
		$tariffMax: Int! = ${MAX_UCAS_TARIFF}
		$region: UniversityRegion = null
		$studyMode: CourseStudyMode = null
		$type: UniversityType = null
		$name: String = null
		$page: Int = 1
		$limit: Int = 10
		$offset: Int = null
	) {
		courses(
			degree_level: $degreeLevel
			min_ucas_tariff: $tariffMin
			max_ucas_tariff: $tariffMax
			region: $region
			study_mode: $studyMode
			type: $type
			name: $name
			page: $page
			limit: $limit
			offset: $offset
		) {
			data {
				id
				name
				slug
				logo
				recommended_percentage
				external_url
				external_prospectus_url
				saved
				courses_count
				cover_image
				paid_features
				privacy_policy_url
				order
				courses {
					id
					slug
					name
					year
					study_mode
					location
					min_ucas_tariff
					max_ucas_tariff
					saved
				}
			}
			subject_keywords {
				id
				title
				description
				external_url
				subject
				university {
					id
					name
				}
			}
			related_subjects {
				name
				courses_count
			}
			per_page
			current_page
			has_more_pages
			total
			filters {
				name
				values {
					id
					count
				}
			}
			universities_count
		}
	}
`;

const GET_CLEARING_COURSES = gql`
	query getClearingCourses(
		$tariffMin: Int
		$tariffMax: Int! = ${MAX_UCAS_TARIFF}
		$degreeIds: [Int]
		$studyOptions: [Int]
		$locationIds: [Int]
		$typeIds: [Int]
		$name: String
		$page: Int
		$limit: Int
		$offset: Int
	) {
		clearingCourses(
			min_ucas_tariff: $tariffMin
			max_ucas_tariff: $tariffMax
			degree_level_ids: $degreeIds
			study_mode_ids: $studyOptions
			location_ids: $locationIds
			type_ids: $typeIds
			name: $name
			page: $page
			limit: $limit
			offset: $offset
		) {
			recommended_courses {
				id
				title
				description
				external_url
				subject
				university {
					id
					name
				}
			}
			data {
				id
				name
				slug
				logo
				recommended_percentage
				external_url
				external_prospectus_url
				privacy_policy_url
				saved
				courses_count
				cover_image
				paid_features
				phone_number
				order
				courses {
					id
					slug
					name
					year
					study_mode
					location
					min_ucas_tariff
					max_ucas_tariff
					saved
				}
			}
			per_page
			current_page
			has_more_pages
			total
			filters {
				name
				values {
					id
					count
				}
			}
		}
	}
`;

const GET_UNIVERSITY_COURSES = gql`
	query getUniversityCourses(
		$slug: String!
		$degreeLevel: CourseDegreeLevel = ALL_UNDERGRADUATE
		$tariffMin: Int
		$tariffMax: Int! = ${MAX_UCAS_TARIFF}
		$studyMode: CourseStudyMode = null
		$name: String = null
		$page: Int
		$limit: Int
		$offset: Int
	) {
		universityCourses(
			slug: $slug
			degree_level: $degreeLevel
			min_ucas_tariff: $tariffMin
			max_ucas_tariff: $tariffMax
			study_mode: $studyMode
			name: $name
			page: $page
			limit: $limit
			offset: $offset
		) {
			id
			slug
			name
			logo
			recommended_percentage
			external_url
			external_prospectus_url
			cover_image
			paid_features
			saved
			privacy_policy_url
			order
			courses {
				data {
					id
					slug
					name

					year
					location
					study_mode
					min_ucas_tariff
					max_ucas_tariff
					saved
				}
				per_page
				current_page
				has_more_pages
				total
				filters {
					name
					values {
						id
						count
					}
				}
			}
		}
	}
`;

const GET_UNIVERSITY_CLEARING_COURSES = gql`
	query getUniversityClearingCourses(
		$uniSlug: String!
		$tariffMin: Int
		$tariffMax: Int! = ${MAX_UCAS_TARIFF}
		$degreeIds: [Int]
		$studyOptions: [Int]
		$name: String
		$page: Int
		$limit: Int
		$offset: Int
	) {
		clearingUniversityCourses(
			slug: $uniSlug
			min_ucas_tariff: $tariffMin
			max_ucas_tariff: $tariffMax
			degree_level_ids: $degreeIds
			study_mode_ids: $studyOptions
			name: $name
			page: $page
			limit: $limit
			offset: $offset
		) {
			id
			slug
			name
			logo
			recommended_percentage
			external_url
			external_prospectus_url
			privacy_policy_url
			cover_image
			paid_features
			saved
			phone_number
			order
			courses {
				data {
					id
					slug
					name
					year
					location
					study_mode
					min_ucas_tariff
					max_ucas_tariff
					saved
				}
				per_page
				current_page
				has_more_pages
				total
				filters {
					name
					values {
						id
						count
					}
				}
			}
		}
	}
`;

export {
	GET_COURSES,
	GET_CLEARING_COURSES,
	GET_UNIVERSITY_COURSES,
	GET_UNIVERSITY_CLEARING_COURSES,
};
